import script from "./LatestReceipts.vue?vue&type=script&setup=true&lang=ts"
export * from "./LatestReceipts.vue?vue&type=script&setup=true&lang=ts"

import "./LatestReceipts.vue?vue&type=style&index=0&id=4417e290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4417e290"]])

export default __exports__